import {
  Box,
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { useState } from "react";
import Header from "./Header";

import { Link } from "react-router-dom";

import companyLogo from "../assets/images/Logo/logo-only-kg.jpg";

import "../assets/css/style.css";
import Sidenav from "../layout/Sidenav";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { handleLogout } from "../commonFunctions/logout";

function Layout(props) {
  const [menuOpenedFlag, setMenuOpenedFlag] = useState(true);
  const showMenuIcon = () => {
    setMenuOpenedFlag(!menuOpenedFlag);
  };

  return (
    <Box>
      <Grid container>
        <Grid
          className={`sidenav ${menuOpenedFlag ? `open` : `close`}`}
          sx={{
            width: menuOpenedFlag ? "300px" : "70px",
            transition: "all 0.3s ease",
            overflowX: "hidden",
            height: "100vh",
            position: "fixed",
            zIndex: 1000,
          }}
        >
          {/* Sidebar inner: flex column, full height */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflow: "hidden",
            }}
          >
            {/* LOGO */}
            <Box
              sx={{
                px: menuOpenedFlag ? 2.5 : 0,
                py: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexShrink: 0,
                borderBottom: "1px solid rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
              }}
            >
              <img
                src={companyLogo}
                alt="KG"
                width={menuOpenedFlag ? `150px` : `55px`}
                height={`auto`}
                style={{ transition: "width 0.3s ease" }}
              />
            </Box>

            {/* MENU ITEMS: scrollable, fills remaining space */}
            <Box sx={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
              <Grid className="left-menu">
                <Sidenav isSidebarOpen={menuOpenedFlag} />
              </Grid>
            </Box>

            {/* LOGOUT: pinned to bottom */}
            <Box sx={{ flexShrink: 0 }}>
              <Link onClick={handleLogout} className={`logout-btn`}>
                <ListItemButton
                  sx={{
                    minHeight: 56,
                    width: "100%",
                    px: menuOpenedFlag ? 2 : 0,
                    display: "flex",
                    justifyContent: menuOpenedFlag ? "flex-start" : "center",
                    alignItems: "center",
                    gap: menuOpenedFlag ? "12px" : 0,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      justifyContent: "center",
                      "& svg": {
                        fontSize: menuOpenedFlag ? "22px" : "26px",
                      },
                    }}
                  >
                    <PowerSettingsNewIcon />
                  </ListItemIcon>
                  {menuOpenedFlag && (
                    <ListItemText
                      primary="Logout"
                      sx={{ "& span": { fontWeight: 600 } }}
                    />
                  )}
                </ListItemButton>
              </Link>
            </Box>
          </Box>
        </Grid>
        {/* <Grid className={`topnav ${!menuOpenedFlag ? 'full-width' : ''}`}>
          <Header menuAction={showMenuIcon} menuOpenedFlag={menuOpenedFlag} />
          {props.children}
        </Grid> */}
        <Grid
          className="topnav"
          sx={{
            marginLeft: menuOpenedFlag
              ? { xl: "316px", lg: "316px", sm: "16px" }
              : "86px",
            width: menuOpenedFlag
              ? {
                  xl: "calc(100vw - 316px)",
                  lg: "calc(100vw - 316px)",
                  sm: "100vw",
                }
              : "calc(100vw - 86px)",
            transition: "all 0.3s ease",
          }}
        >
          <Header
            menuAction={showMenuIcon}
            menuOpenedFlag={menuOpenedFlag}
            isHovered={false}
          />
          {props.children}
        </Grid>
      </Grid>
    </Box>
  );
}

export default Layout;
